"use client"
import type { BookingContent } from "./small-content"
import { ScrollReveal } from "@/components/scroll/ScrollReveal"
import { Footer } from "@/components/layout/Footer"
import { GHLBookingWidget } from "@/components/ui/GHLBookingWidget"

const BG = "#0B0F1C"
const ACCENT = "#C4541A"
const MUTED = "rgba(255,255,255,0.6)"
const BORDER = "rgba(255,255,255,0.08)"

export function BookingClient({ content }: { content: BookingContent }) {
  return (
    <main style={{ background: BG, color: "#fff", minHeight: "100vh" }}>
      <section style={{ padding: "clamp(100px, 14vw, 140px) clamp(20px, 4vw, 48px) 60px", maxWidth: 1000, margin: "0 auto" }}>
        <ScrollReveal effect="fade-up">
          <div style={{ display: "flex", gap: 16, alignItems: "center", marginBottom: 32 }}>
            <span style={{ width: 32, height: 1, background: ACCENT, flexShrink: 0 }} />
            <span style={{ fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase", color: MUTED }}>{content.eyebrow}</span>
          </div>
          <h1 style={{ fontSize: "clamp(40px, 7vw, 100px)", fontWeight: 900, letterSpacing: "-0.04em", lineHeight: 0.88, marginBottom: 24 }}>
            {content.headingLine1}<br /><span style={{ color: ACCENT }}>{content.headingLine2}</span>
          </h1>
          <p style={{ fontSize: "clamp(15px, 1.3vw, 19px)", color: MUTED, maxWidth: 480, lineHeight: 1.65, marginBottom: 64 }}>
            {content.intro}
          </p>
        </ScrollReveal>

        <ScrollReveal effect="fade-up" delay={0.12}>
          {/* No height cap / inner scroll here: the widget sizes itself to the
              calendar's reported height, so the whole booking flow is visible
              and only the page scrolls. */}
          <GHLBookingWidget
            src={content.bookingSrc}
            id={`${content.bookingId}_booking`}
            title={content.bookingTitle}
            defaultHeight={1000}
            borderRadius={12}
            border={`1px solid ${BORDER}`}
            background="rgba(255,255,255,0.03)"
            redirectTo="/thank-you"
            deferLoad
          />
        </ScrollReveal>
      </section>

      <Footer />
    </main>
  )
}